import React, { useState, useEffect } from "react";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";

export default function TestimonialsCarousel() {
  const testimonials = [
    {
      stars: 5,
      text: "SoloConnect made my trip to Bali unforgettable. I met amazing people and felt safe throughout.",
      name: "Priya S.",
      country: "India",
      img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=120&h=120&q=80"
    },
    {
      stars: 5,
      text: "I found the perfect travel buddy for my Europe trip. The app is a game changer!",
      name: "James L.",
      country: "Australia",
      img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=120&h=120&q=80"
    },
    {
      stars: 5,
      text: "The AI recommendations and community support are simply awesome!",
      name: "Maria K.",
      country: "Germany",
      img: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=120&h=120&q=80"
    },
    {
      stars: 5,
      text: "Solo travel felt intimidating before, but this community made it easy and fun.",
      name: "Diego R.",
      country: "Mexico",
      img: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=120&h=120&q=80"
    },
     {
      stars: 5,
      text: "Solo travel felt intimidating before, but this community made it easy and fun.",
      name: "Diego R.",
      country: "Mexico",
      img: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=120&h=120&q=80"
    },
    
  ];

  // itemsPerView switches between mobile (1 card) and desktop (3 cards)
  const [itemsPerView, setItemsPerView] = useState(3);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const updateItemsPerView = () => {
      setItemsPerView(window.innerWidth < 768 ? 1 : 3);
    };
    updateItemsPerView();
    window.addEventListener("resize", updateItemsPerView);
    return () => window.removeEventListener("resize", updateItemsPerView);
  }, []);

  const maxIndex = Math.max(0, testimonials.length - itemsPerView);

  // keep currentIndex valid when itemsPerView changes (e.g. resize)
  useEffect(() => {
    setCurrentIndex((prev) => Math.min(prev, maxIndex));
  }, [maxIndex]);

  const handleNext = () => {
    setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
  };

  const slideWidth = 100 / itemsPerView;

  return (
    <section className="py-8 md:py-10 bg-[#f4f2fb]">
      <div className="max-w-7xl mx-auto px-6 text-center space-y-6">

        {/* Section header */}
        <div>
          <span className="text-[11px] font-extrabold text-purple-500 uppercase tracking-widest block mb-1.5">
            What Travelers Say
          </span>
          <h2 className="text-2xl md:text-3xl font-extrabold text-slate-900">
            Trusted by Thousands <span className="text-purple-600">of Solo Travelers</span>
          </h2>
        </div>

        {/* Sliding testimonials */}
        <div className="relative max-w-6xl mx-auto px-8 sm:px-14">

          <button
            onClick={handlePrev}
            className="absolute left-0 sm:-left-2 top-1/2 -translate-y-1/2 w-9 h-9 md:w-10 md:h-10 bg-white hover:bg-purple-50 text-slate-700 rounded-full shadow-md flex items-center justify-center active:scale-95 transition-all z-20"
            aria-label="Previous testimonial"
          >
            <ChevronLeft className="w-4 h-4" />
          </button>

          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-500 ease-out"
              style={{ transform: `translateX(-${currentIndex * slideWidth}%)` }}
            >
              {testimonials.map((item, idx) => (
                <div
                  key={idx}
                  className="shrink-0 px-2"
                  style={{ width: `${slideWidth}%` }}
                >
                  <div className="bg-white rounded-2xl p-5 shadow-sm flex flex-col justify-between space-y-4 text-left h-full">
                    <div>
                      <div className="flex justify-between items-center mb-2.5">
                        <div className="flex gap-0.5 text-purple-500">
                          {[...Array(Math.min(item.stars, 5))].map((_, i) => (
                            <Star key={i} className="w-3.5 h-3.5 fill-current" />
                          ))}
                        </div>
                        {/* <ArrowUpRight className="w-4 h-4 text-slate-300" /> */}
                      </div>

                      <p className="text-xs md:text-sm text-slate-500 leading-relaxed">
                        "{item.text}"
                      </p>
                    </div>

                    <div className="flex items-center gap-2.5 pt-1">
                      <img
                        src={item.img}
                        alt={item.name}
                        className="w-9 h-9 rounded-full object-cover"
                      />
                      <div>
                        <h4 className="font-extrabold text-slate-900 text-xs">{item.name}</h4>
                        <p className="text-[11px] text-slate-400 font-medium">{item.country}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button
            onClick={handleNext}
            className="absolute right-0 sm:-right-2 top-1/2 -translate-y-1/2 w-9 h-9 md:w-10 md:h-10 bg-white hover:bg-purple-50 text-slate-700 rounded-full shadow-md flex items-center justify-center active:scale-95 transition-all z-20"
            aria-label="Next testimonial"
          >
            <ChevronRight className="w-4 h-4" />
          </button>
        </div>

        {/* Progress dots */}
        <div className="flex justify-center gap-1.5 pt-1">
          {Array.from({ length: maxIndex + 1 }).map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentIndex(idx)}
              className={`h-1.5 rounded-full transition-all ${
                idx === currentIndex ? "w-5 bg-purple-500" : "w-1.5 bg-purple-200"
              }`}
              aria-label={`Go to slide ${idx + 1}`}
            />
          ))}
        </div>

      </div>
    </section>
  );
}